import { BREATH_SEGMENTS } from '@muzly/voice-engine';
import type { BreathSegment, BreathSegmentId } from '@muzly/voice-engine';

/**
 * 호흡 세 구간을 **그 회차가 실제로 나눈 초**와 함께 낸다 — 화면이 그리는 줄의 정본.
 *
 * 구간 경계는 이제 테이크 길이의 비율이라(`BREATH_SEGMENTS`) 회차마다 다르다. 6초 테이크는
 * `0~1.8초 / 1.8~4.2초 / 4.2~6초`로 나뉘고, 10초 테이크는 시안의 `0~3 / 3~7 / 7~10`이 된다.
 * 그래서 초는 상수가 아니라 **회차에 실려 온다**(`BreathSegment.fromSec`).
 *
 * **초가 없는 회차가 있다.** 비율이 되기 전에 저장된 회차와, 서버에서 복원한 회차다(서버
 * 계약 `AnalyBreathSegment`는 `id`와 `score`만 나른다). 그 줄의 초는 `null`이고 화면은 구간
 * 이름만 쓴다. 옛 고정 초(0~3/3~7/7~10)로 채우면 서버에서 복원한 6초 테이크의 `후반`이
 * 녹음이 끝난 뒤를 가리키고, 새 비율로 다시 계산하면 재지도 않은 경계를 사실처럼 말한다 —
 * 둘을 가를 필드가 레코드에 없다.
 *
 * React·저장소 IO 의존 없음 — vitest 대상.
 */

export interface BreathRow {
  id: BreathSegmentId;
  /** 그 회차가 실제로 자른 초. 레코드에 없으면 null — 지어내지 않는다. */
  fromSec: number | null;
  toSec: number | null;
  /** 표본이 모자란 구간은 없다. 0이 아니다. */
  score: number | null;
}

export const breathRows = (segments: readonly BreathSegment[]): BreathRow[] =>
  BREATH_SEGMENTS.map(({ id }) => {
    const found = segments.find((s) => s.id === id);
    return {
      id,
      fromSec: found?.fromSec ?? null,
      toSec: found?.toSec ?? null,
      score: found?.score ?? null,
    };
  });
